import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import SupplierFilter from '../../components/quantila/supplier_filter';
import FooterProfile from '../../components/footer_profile';
import SupplierTable from '../../components/quantila/suppliers_table';
import Navbar from '../../components/navbar';
import isLoggedIn from '../../utils/isLoggedIn';
import { convertEntitiesDeep } from '../../utils/convertEntities';

const Suppliers = () => {
  const url = `${process.env.REACT_APP_API}`;
  const token = sessionStorage.getItem('token');
  const [isLoading, setLoading] = useState(true);
  const [count, setCount] = useState();
  const [suppliers, setSuppliers] = useState([]);
  const [filters, setFilters] = useState({
    country: '',
    searchStr: '',
    displayCount: 20,
    page: 1,
    // Suppliers default to unvalidated results unless the user changes the filter
    isValidated: false,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const getSuppliers = async () => {
      const { searchStr, displayCount, isValidated, country, page } = filters;
      const response = await axios.get(`${url}/admin/quantila/suppliers`, {
        headers: { authorization: `Bearer ${token}` },
        params: { searchStr, displayCount, isValidated, country, page },
      });
      const [supplierCount, supplierList] = convertEntitiesDeep(response.data);
      setSuppliers(supplierList);
      setCount(supplierCount);
      setLoading(false);
    };

    isLoggedIn(navigate, dispatch, '/quantila/suppliers');
    const timeoutId = setTimeout(getSuppliers, 300);

    return () => {
      clearTimeout(timeoutId);
      setLoading(false);
    };
  }, [filters]);

  return isLoading ? (
    <>
      <Helmet>
        <title>Badgers SAS: Suppliers</title>
        <meta name='page' content='quantila suppliers' />
      </Helmet>
      <div className='loading'>
        <img src='/img/loading.gif' alt='Loading' className='loading-img' />
      </div>
    </>
  ) : (
    <>
      <Helmet>
        <title>Badgers SAS: Suppliers</title>
        <meta name='page' content='quantila suppliers' />
      </Helmet>
      <Navbar displayMob={true} />
      <div>
        <SupplierFilter
          count={count}
          filters={filters}
          setFilters={setFilters}
          displayMob={true}
        />
        <div className='container'>
          <div>
            <Link className='page-links' to='/'>
              <FontAwesomeIcon icon='home' />{' '}
            </Link>
            <span className='link-span'>
              <FontAwesomeIcon icon='angle-right' />
            </span>
            <span className='link-span'>SUPPLIERS</span>
          </div>
          <div className='container'>
            <div className='col-12 d-flex justify-content-center my-4'>
              <h4 className='h4'>
                SUPPLIERS <FontAwesomeIcon icon='building' />
              </h4>
            </div>
            <SupplierTable suppliers={suppliers} />
          </div>
        </div>
        <FooterProfile />
      </div>
    </>
  );
};

export default Suppliers;
